let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7rEYM"), load("69XGw")]).then(() => parcelRequire('lJ0CS'));